import React from 'react'
import styles from './styles.module.scss'

type ColorProps = {
  children: React.ReactNode
}
const Color = ({ children }: ColorProps) => {
  return <div className={styles.productForm__colors}>{children}</div>
}

export default Color
